'use strict';

module.exports = ['Vimeo'];